<template>
  <div class="page-wrap">
    <div class="page-container">
      <!-- 搜索筛选卡片 毛玻璃+大圆角+弥散阴影 -->
      <div class="search-card">
        <el-form inline>
          <el-form-item label="短剧名称(精准)：">
            <el-input placeholder="每行一个精准短剧名称，敲击回车换行" :rows="3" type="textarea" v-model="desc"
              @change="handleInputChange"></el-input>
          </el-form-item>
          <el-form-item label="平台编码:">
            <el-select v-model="platformCode" :disabled="true" clearable placeholder="请选择平台编码" size="mini"
              style="width:200px">
              <el-option v-for="item in platformList" :key="item.platformCode" :label="item.platformName"
                :value="item.platformCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" size="mini" @click="booklistFun()">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="btn-toolbar">
        <!-- 左侧按钮组 -->
        <div class="left-buttons">
          <el-button-group class="my-btn-group">

          </el-button-group>
          <el-button plain size="mini" icon="el-icon-coin" class="btn-green"
            @click="changeVideoviewFun()">手动添加短剧（兜底）</el-button>
          <el-button @click="changeaddPromotionviewFun()" plain size="mini" class="btn-dark-blue">调用平台创建新链接</el-button>
          <el-button @click="changeSDaddPromotionviewFun()" plain size="mini" class="btn-purple">手动添加推广链接</el-button>
          <el-button @click="changePTseletctPromotionviewFun()" plain size="mini"
            class="btn-green">从平台拉取已有链接</el-button>
          <p style="color:#f53f3f;font-size:12px;font-weight:500;letter-spacing:1px;line-height:1.6;">
            短剧不存在的时候请手动添加；推广链接不存在请手动或调用平台创建链接;
          </p>
        </div>
      </div>

      <!-- 下方表格卡片 -->
      <div class="table-card">
        <el-table :data="linkCheckData" border style="width: 100%">
          <el-table-column label="状态" width="130">
            <template #default="scope">
              <span :style="{ color: scope.row.status == false ? '#f56c6c' : '#67c23a' }">
                {{ scope.row.status == false ? '未选中链接' : '已选中' + scope.row.playletSeriesUrlInfo.length + '条' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="dramaName" label="短剧名称" width="340"> </el-table-column>
          <el-table-column prop="dramaId" label="短剧id" width="200"> </el-table-column>
          <el-table-column prop="playletId" label="抖音作品id" width="200"> </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-button type="text" @click="bookpromotionListFun(scope)">选择链接</el-button>
              <el-button type="text" @click="changeaddPromotionviewFunScope(scope)">调用平台创建新链接</el-button>
              <el-button type="text" @click="changeSDaddPromotionviewFunScope(scope)">手动添加推广链接</el-button>
              <el-button type="text" @click="changePTseletctPromotionviewFunScope(scope)">从平台拉取已有链接</el-button>


            </template>

          </el-table-column><el-table-column label="删除" width="80" align="center"><template #default="scope"><el-button type="text" style="color:#f56c6c" @click="removeLinkRow(scope)">删除</el-button></template></el-table-column>
          <!-- <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column> -->

          <!-- <el-table-column prop="regionRemark" label="操作" width="100">
            <template #default="scope">
              <el-button type="danger" @click="titledeleteFun2(scope)" icon="el-icon-delete" circle
                size="mini"></el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="search-card" v-if="linkCheckData.length > 0">
        <el-button type="success" size="mini" @click="submitFun()">确定</el-button>
      </div>

      <!-- 分页 -->
      <!-- <div class="pagination-wrap">
        <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
          :pagesize="pagesize" :currentPage="currentPage"></pagination>
      </div> -->
    </div>

    <!-- 添加短剧弹窗控制 -->
    <el-dialog title="添加短剧" v-model="Videoview" width="60%" class="dialog‑green">
      <el-form :model="form" label-width="120px">
        <el-form-item label="短剧平台">
          <el-select v-model="form.platformCode" clearable @click="bookplatformListFun()" placeholder="请选择短剧平台"
            style="width:520px">
            <el-option v-for="item in platformList" :key="item.platformCode" :label="item.platformName"
              :value="item.platformCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" v-if="form.platformCode == '番茄短剧'">
          <el-select v-model="form.type" clearable placeholder="请选择账户" style="width:520px">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.platformCode == '番茄短剧'">
          <p style="color:#f53f3f;font-size:12px;font-weight:500;letter-spacing:1px;line-height:1.6;">
            由于番茄平台限制，一次最多添加3条
          </p>
        </el-form-item>
        <el-form-item label="短剧id">
          <el-input v-model="form.remark" type="textarea" :rows="24"
            :placeholder="'短剧id多个时请换行输入,如\n123456\n789012\n345678'" style="width:520px"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="mini" @click="bookaddBatchFun()">添加短剧</el-button>
          <!-- <el-button v-if="sId != ''" type="primary" size="mini" @click="packageupdateFun()">修改短剧</el-button> -->
          <el-button size="mini" @click="handleResetPackage()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 查看链接管理弹窗控制 -->
    <el-dialog v-model="selectPromotionview" title="选中链接" width="80%">
      <div class="selBTN" style="display:flex;align-items:center;gap:12px;margin-bottom:10px;">
        <el-input v-model="remarkKeyword" placeholder="输入备注筛选（仅页面过滤）" clearable style="width:320px;" />
        <span style="color:#909399;font-size:12px;">共 {{ PromotionData.length }} 条，筛选出 {{ filteredPromotionData.length }} 条</span>
      </div>
      <el-table ref="promotionTableRef" :data="filteredPromotionData" row-key="promotionId" border style="width: 100%"
        @selection-change="handleSelectionChange" @row-click="handlePromotionRowClick"
        :row-class-name="promotionRowClassName">
        <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
        <!-- <el-table-column prop="platformCode" label="短剧平台" width="120"> </el-table-column> -->
        <!-- <el-table-column prop="bookId" label="短剧id" width="180"> </el-table-column> -->
        <el-table-column prop="playletSeriesUrlType" label="类型" width="60"> </el-table-column>
        <el-table-column prop="promotionName" label="推广链接名称" width="280"> </el-table-column>
        <el-table-column prop="remark" label="备注" width="580"> </el-table-column>
        <el-table-column prop="promotionId" label="推广链接id" width="160"> </el-table-column>
        <el-table-column prop="promotionUrl" label="推广链接">
          <template #default="scope">
            <span style="color:#409eff;cursor:pointer;text-decoration:underline;"
              @click.stop="copyUrl(scope.row.promotionUrl)">
              {{ '复制推广链接' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"> </el-table-column>
        <!-- <el-table-column prop="address" label="地址"> </el-table-column> -->
      </el-table>
      <div class="selBTN">
        <el-button type="warning" @click="selectPromotionviewConfirm()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 调用平台创建新链接弹窗控制 -->
    <el-dialog v-model="addPromotionview" title="调用平台创建新链接" width="60%">
      <ylycreatePromotion v-if="addPromotionview" :data="{ platformCode, selectPromotionData }"
        @zdgetCannelFun="zdgetCannelFun">
      </ylycreatePromotion>
    </el-dialog>

    <!-- 手动添加链接弹窗控制 -->
    <el-dialog v-model="SDaddPromotionview" title="手动添加链接" width="60%" destroy‑on‑close>
      <ylySDcreatePromotion v-if="SDaddPromotionview" :data="{ platformCode, selectPromotionData }"
        @sdgetCannelFun="sdgetCannelFun">
      </ylySDcreatePromotion>
    </el-dialog>


    <!-- 从平台拉取链接弹窗控制 -->
    <el-dialog v-model="PTseletctPromotionview" title="从平台拉取已有链接" width="60%" destroy‑on‑close>
      <ylyPTseletctPromotion v-if="PTseletctPromotionview" :data="{ platformCode, selectPromotionData }"
        @PTgetCannelFun="PTgetCannelFun">
      </ylyPTseletctPromotion>
    </el-dialog>

  </div>
</template>

<script>
import { bookaddBatch, bookplatformList, booklist, bookaddPromotion, bookpromotionList } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { inject, reactive, ref, toRefs, watch, computed, nextTick } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件
import ylycreatePromotion from '@/components/ylyBatch/ylycreatePromotion.vue' // 导入自动创建链接
import ylySDcreatePromotion from '@/components/ylyBatch/ylySDcreatePromotion.vue' // 导入手动创建链接
import ylyPTseletctPromotion from '@/components/ylyBatch/ylyPTseletctPromotion.vue' // 导入平台拉取链接


export default {
  name: 'ylylinkCheck',
  components: { pagination, ylycreatePromotion, ylySDcreatePromotion, ylyPTseletctPromotion },

  props: ['data', 'linkCheckData'],
  setup(props, context) {
    const parent = { ...context }
    const promotionTableRef = ref(null)
    const state = reactive({
      //平台编码（精确）
      platformCode: props.data.platformCode,
      //平台短剧ID（精确）
      platformDramaId: '',
      // 变现类型
      // monetizeMode:props.data.monetizeMode,
      //短剧名称（模糊）
      name: '',
      desc: '',
      // 批量剧名
      names: [],
      //选中的id
      sId: [],
      //表格数据
      tableData: [],
      //所有启用的平台的数据
      platformList: [],
      //查看链接的数据
      PromotionData: [],
      //备注筛选关键字（仅页面过滤）
      remarkKeyword: '',
      //查看链接的数据
      linkCheckData: props.linkCheckData,
      linkCheckDataIndex: '',
      // 当前操作的行 scope（用于创建/拉取链接后自动刷新该行链接列表）
      currentRowScope: null,
      // 选中的短剧添加到窗口
      selectPromotionData: '',
      //类型数据
      typeList: [{ label: '端真人剧', value: '端真人剧' }, { label: '端漫剧', value: '端漫剧' }],

      //短剧重置数据
      restform: {
        platformCode: '',
        type: '',
        bookIds: [],
        remark: ''
      },
      //添加短剧的数据
      form: {
        platformCode: '',
        type: '',
        bookIds: [],
        remark: ''
      },
      //添加短剧开关
      Videoview: false,
      //添加短剧开关控制
      changeVideoviewFun: () => {
        state.Videoview = !state.Videoview
      },
      //查看链接
      selectPromotionview: false,
      //查看链接开关控制
      changeselectPromotionviewFun: () => {
        state.selectPromotionview = !state.selectPromotionview
      },
      //调用平台创建新链接
      addPromotionview: false,
      //调用平台创建新链接开关控制
      changeaddPromotionviewFun: () => { state.selectPromotionData = ''; state.currentRowScope = null; 
        state.addPromotionview = !state.addPromotionview
      },
      //手动添加链接
      SDaddPromotionview: false,
      //手动添加链接开关控制
      changeSDaddPromotionviewFun: () => { state.selectPromotionData = ''; state.currentRowScope = null; 
        state.SDaddPromotionview = !state.SDaddPromotionview
      },
      //从平台拉取已有链接
      PTseletctPromotionview: false,
      //从平台拉取已有链接开关控制
      changePTseletctPromotionviewFun: () => { state.selectPromotionData = ''; state.currentRowScope = null; 
        state.PTseletctPromotionview = !state.PTseletctPromotionview
      },
      //监听把输入的数据变成账号数组
      handleInputChange: () => {
        state.names = state.desc.split('\n').map(item => item.trim()).filter(item => item !== '');
      },


      //复制url
      copyUrl: (url) => {
        navigator.clipboard.writeText(url)
        ElMessage.success('复制成功')
      },
      //
      zdgetCannelFun: () => {
        state.selectPromotionData = ''
        state.changeaddPromotionviewFun()
        if (state.currentRowScope) {
          state.bookpromotionListFun(state.currentRowScope)
        }
      },
      sdgetCannelFun: () => {
        state.selectPromotionData = ''
        state.changeSDaddPromotionviewFun()
        if (state.currentRowScope) {
          state.bookpromotionListFun(state.currentRowScope)
        }
      },
      PTgetCannelFun: () => {
        state.selectPromotionData = ''
        state.changePTseletctPromotionviewFun()
        if (state.currentRowScope) {
          state.bookpromotionListFun(state.currentRowScope)
        }
      },


      //删除按钮
      titledeleteFun2: (scope) => {
        state.sId = [scope.row.id]
        state.changeselectPromotionviewFun()
      },
      // 条数
      pagesize: 100,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 0,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        booklistFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        booklistFun()
      },
      //重置短剧
      handleResetPackage: () => {
        // 深拷贝 restform，切断引用
        state.form = JSON.parse(JSON.stringify(state.restform))
      },
      //添加短剧
      bookaddBatchFun: () => {

        if (state.form.platformCode.length > 0 && state.form.type != '' && state.form.remark.length > 0) {
          state.form.bookIds = state.form.remark.split('\n').map(item => item.trim()).filter(item => !!item)
          if (state.form.platformCode == '番茄短剧' && state.form.bookIds.length > 3) {
            return ElMessage.error('短剧id不能超过3个')
          }
          const datas = {
            platformCode: state.form.platformCode,
            type: state.form.type,
            bookIds: state.form.bookIds,
          }
          bookaddBatch(datas).then((res) => {
            if (res.code == 200) {
              ElMessage.success('添加成功，请稍后使用')
              state.form = JSON.parse(JSON.stringify(state.restform))
              state.changeVideoviewFun()
              // booklistFun()
            }
          })
        } else {
          ElMessage.error('数据不能为空')
        }
      },
      // 短剧调用平台创建新链接
      changeaddPromotionviewFunScope: (scope) => {
        state.selectPromotionData = scope.row.dramaName
        state.currentRowScope = scope
        state.addPromotionview = true
      },
      // 短剧手动添加链接 
      changeSDaddPromotionviewFunScope: (scope) => {
        state.selectPromotionData = scope.row.dramaName
        state.currentRowScope = scope
        state.SDaddPromotionview = true
      },
      // 从平台拉取已有链接
      changePTseletctPromotionviewFunScope: (scope) => {
        state.selectPromotionData = scope.row.dramaName
        state.currentRowScope = scope
        state.PTseletctPromotionview = true
      },


      removeLinkRow: (scope) => { const i=scope.$index; if(i>-1){ state.linkCheckData.splice(i,1) } },//批量查看链接
      bookpromotionListFun: (scope) => {
        console.log(scope)
        const datas = {
          bookId: scope.row.dramaId,
          monetizeMode: props.data.monetizeMode,
        }

        bookpromotionList(datas).then((res) => {
          if (res.code == 200) {
            state.PromotionData = res.data || []
            state.remarkKeyword = ''
            state.linkCheckDataIndex = scope.$index
            state.changeselectPromotionviewFun()
            nextTick(() => {
              promotionTableRef.value?.clearSelection()
              const checked = state.linkCheckData?.[state.linkCheckDataIndex]?.playletSeriesUrlInfoData || []
              if (!checked.length) return
              const checkedIds = new Set(checked.map((item) => item.promotionId))
              ;(state.PromotionData || []).forEach((row) => {
                if (checkedIds.has(row.promotionId)) {
                  promotionTableRef.value?.toggleRowSelection(row, true)
                }
              })
            })
          } else {
            ElMessage.error(res.msg)
          }

        })
      },
      //确定选中链接
      selectPromotionviewConfirm: () => {
        const checkedList = state.linkCheckData[state.linkCheckDataIndex].playletSeriesUrlInfoData || []
        if (checkedList.length === 0) {
          return ElMessage.error('请勾选链接')
        }
        console.log('playletSeriesUrlInfoData ', checkedList)
        console.log('checkedList ', checkedList)
        // const iapCount = checkedList.filter((item) => item.playletSeriesUrlType === 'IAP').length
        const iapCount = checkedList.filter((item) => item.playletSeriesUrlType === 'IAP').length

        if (iapCount < 1) {
          return ElMessage.error('至少选中一条IAP链接')
        }
        const iaaCount = checkedList.filter((item) => item.playletSeriesUrlType === 'IAA').length
        if (iaaCount > 1) {
          return ElMessage.error('最多只能选中一条IAA链接')
        }
        state.linkCheckData[state.linkCheckDataIndex].status = true
        state.linkCheckData[state.linkCheckDataIndex].playletSeriesUrlInfo = state.linkCheckData[state.linkCheckDataIndex].playletSeriesUrlInfoData
        console.log('promotionUrl判断是否为null', state.linkCheckData[state.linkCheckDataIndex].playletSeriesUrlInfoData[0].promotionUrl)
        console.log('playletSeriesUrlInfoData[0]', state.linkCheckData[state.linkCheckDataIndex].playletSeriesUrlInfoData[0])
        console.log('下标linkCheckDataIndex', state.linkCheckDataIndex)

        // 判断是否为预打链接
        if (state.linkCheckData[state.linkCheckDataIndex].playletSeriesUrlInfoData[0].promotionUrl == null) {
          console.log('预打链接 ')
          // 预打链接
          state.linkCheckData[state.linkCheckDataIndex].readLinkType = true
        } else {
          // 非预打链
          console.log('非预打链 ')
          state.linkCheckData[state.linkCheckDataIndex].readLinkType = false
        }
        state.selectPromotionview = false
      },
      // 不同类型行背景色：IAA 淡绿 / IAP 淡蓝
      promotionRowClassName: ({ row }) => {
        if (row.playletSeriesUrlType === 'IAA') return 'row-iaa'
        if (row.playletSeriesUrlType === 'IAP') return 'row-iap'
        return ''
      },
      // 获取复选框的值
      handleSelectionChange: (val) => {
        if (state.linkCheckDataIndex === '' || !state.linkCheckData[state.linkCheckDataIndex]) return
        state.linkCheckData[state.linkCheckDataIndex].playletSeriesUrlInfo = []
        state.linkCheckData[state.linkCheckDataIndex].playletSeriesUrlInfoData = val || []
      },
      // 点击行（除推广链接列外）勾选/取消勾选当前行
      handlePromotionRowClick: (row, column) => {
        if (column && column.property === 'promotionUrl') return
        promotionTableRef.value?.toggleRowSelection(row)
      },
      //提交
      submitFun: () => {
        // 是否全部选中
        const allChecked = state.linkCheckData.every(row => row.status === true)
        if (allChecked) {
          // const payload = JSON.parse(JSON.stringify(state.linkCheckData))
          // console.log('全部选中', payload)
          console.log('全部选中', state.linkCheckData)


          //切断引用地址？
          // parent.emit('linkCheckDataFun', structuredClone(state.linkCheckData))
          parent.emit('linkCheckDataFun', JSON.parse(JSON.stringify(state.linkCheckData)))
        } else {
          ElMessage.warning('请全部选中链接')
        }
      }




    })

    // 备注筛选（仅页面过滤，不请求接口）放在 setup 顶层，避免 TDZ 报错
    const filteredPromotionData = computed(() => {
      const kw = (state.remarkKeyword || '').trim().toLowerCase()
      if (!kw) return state.PromotionData
      return (state.PromotionData || []).filter((item) =>
        String(item.remark || '').toLowerCase().includes(kw)
      )
    })

    //分页查询当前登录用户的短剧
    const booklistFun = () => {
      if (state.names.length > 0) {
        const datas = {
          platformCode: state.platformCode,
          platformDramaId: state.platformDramaId,
          name: state.name,
          currentPage: state.currentPage,
          size: state.pagesize,
          names: state.names
        }
        console.log('分页查询当前登录用户的短剧datas', datas)
        booklist(datas).then((res) => {
          // state.currentPage = res.data.currenPage
          // state.total = res.data.totalSize
          const list = (res.data && res.data.data) || []
          state.tableData = list
          console.log('booklist(dataslist', list)
          console.log('booklist(datas前', state.linkCheckData)

          const existIds = new Set((state.linkCheckData||[]).map(x=>x.dramaId))

          // state.linkCheckData = list.map((item) => ({
          // 为了防止重新赋值出现问题
          const newArr = list.map((item) => ({
            playletId: item.playletId,
            dramaId: item.platformDramaId,
            dramaName: item.name,
            playletSeriesUrlInfo: [],
            playletSeriesUrlInfoData: [],
            status: false
          }))
          const addArr=newArr.filter(x=>!existIds.has(x.dramaId));state.linkCheckData.unshift(...addArr)

          console.log('booklist(datas)后', state.linkCheckData)
        })
      } else {
        ElMessage.error('请输入精准剧名')
      }

    }


    //分销平台下拉框（查询所有启用的平台）
    const bookplatformListFun = () => {
      bookplatformList().then((res) => {
        state.platformList = res.data
      })
    }

    bookplatformListFun()


    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      promotionTableRef,
      filteredPromotionData,
      booklistFun,
      bookplatformListFun,
    }
  },

}
</script>

<style lang="scss" scoped>
// 全局页面浅色渐变背景
.page-wrap {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #f7f9fc 0%, #edf2fa 100%);
}

.page-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

// 搜索卡片：毛玻璃、大圆角、弥散柔和阴影
.search-card {
  border-radius: 18px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  transition: all 0.32s ease;
}

// 表格卡片
.table-card {
  border-radius: 18px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  overflow: hidden;
}

.pagination-wrap {
  padding: 8px 4px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.left-buttons {
  display: flex;
  gap: 2px;
  flex-shrink: 1;
  overflow-x: auto;
  padding-bottom: 4px;
}

// ========= ElementPlus 组件深度修改 现代UI 大圆角+hover平滑动画 =========
:deep() {

  // 输入框、选择器大圆角
  .el-input__inner,
  .el-select .el-input__inner {
    border-radius: 12px !important;
    border-color: #e2e8f0;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);

    &:hover {
      border‑color: #b8c8e3;
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.08);
    }

    &:focus {
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
    }
  }

  // 按钮统一大圆角+平滑hover微交互
  .el-button {
    border‑radius: 12px !important;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);
    box‑shadow: 0 2px 6px rgba(0, 0, 0, 0.04);

    &:hover {
      transform: translateY(-1px);
      box‑shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
    }

    &:active {
      transform: translateY(0px);
    }
  }

  // 表格样式美化，去掉生硬边框，圆角
  .el-table {
    border‑radius: 14px;
    overflow: hidden;
  }

  .el-table th.el-table__cell {
    background‑color: #f4f7fc !important;
  }

  .el-table__row:hover>td {
    background‑color: rgba(64, 158, 255, 0.04) !important;
  }

  // 弹窗 毛玻璃大圆角弥散阴影
  .modern-dialog.el-dialog {
    border‑radius: 20px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.78);
    backdrop‑filter: blur(16px);
    -webkit‑backdrop‑filter: blur(16px);
    box‑shadow: 0 12px 45px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.9);
  }

  .el-dialog__header {
    padding: 22px 26px 12px;
  }

  .el-dialog__body {
    padding: 10px 26px 22px;
  }

  // 分页组件圆角
  .el-pagination {

    .el-pager li,
    .el-pagination__btn {
      border‑radius: 10px;
    }
  }
}

/* 你的按钮颜色样式保留 */
.btn-orange {
  background-color: #ff9500;
  color: white;
  border: none;
}

.btn-green {
  background-color: #00b42a;
  color: white;
  border: none;
}

.btn-blue {
  background-color: #409eff;
  color: white;
  border: none;
}

.btn-dark-blue {
  background-color: #2b5cb8;
  color: white;
  border: none;
}

.btn-purple {
  background-color: #722ed1;
  color: white;
  border: none;
}

.btn-red {
  background-color: #f53f3f;
  color: white;
  border: none;
}

.btn-dark {
  background-color: #1d2129;
  color: white;
  border: none;
}

.btn-light-blue {
  background-color: #69b1ff;
  color: white;
  border: none;
}

.btn-sky {
  background-color: #40c9ff;
  color: white;
  border: none;
}

.selBTN {
  // justify-content: flex-end
  margin-top: 10px;
}

// IAA 整行淡绿色 / IAP 整行淡蓝色（选中链接弹窗表格）
::v-deep(.el-table .row-iaa > td) {
  background-color: #e8f5e9 !important;
}
::v-deep(.el-table .row-iap > td) {
  background-color: #e3f2fd !important;
}
::v-deep(.el-table .el-table__row.row-iaa:hover > td) {
  background-color: #d5edda !important;
}
::v-deep(.el-table .el-table__row.row-iap:hover > td) {
  background-color: #cfe6fc !important;
}
</style>